<template>
  <div class="state-radio-datepicker-button">
    <p class="state-radio-datepicker-button_title">
      {{ $t(title) }}<span v-if="required">*</span><span
        v-if="date != ''&& extensionPeriod && extensionPeriod!==0"
        class="black"
      >（ {{ $t('法定展延期限') }} {{ _statitoryExtensionPeriod }} ）</span>
    </p>
    <div class="radio-button input small">
      <label class="radio-button-container">
        <input
          v-model="remindDateSetting"
          type="radio"
          name="remind-day"
          value="auto"
          checked
        >
        <i class="icon-radio-button-unchecked radio-button-container__icon" />
        <i class=" icon-radio-button-checked radio-button-container__icon" />
        <p class="input-text">{{ `${$t('系統自動設定')} (${$t('建議法定展延期限前{number}天',{number:_recommendPeriod})}` }}<span
            v-if="date && _recommendNotifyPeriod"
            class="black"
          >{{ `:${_recommendNotifyPeriod}` }}</span>{{')'}}
        </p>
      </label>
      <div class="radio-button-container">
        <label
          class="radio-button-container"
          style="width:auto;"
        >
          <input
            v-model="remindDateSetting"
            type="radio"
            name="remind-day"
            value="custom"
          >
          <i class="icon-radio-button-unchecked radio-button-container__icon" />
          <i class=" icon-radio-button-checked radio-button-container__icon" />
          <p class="input-text">{{ $t('自訂提醒日') }}</p>
        </label>
        <div
          class="input"
          style="width:100%"
        >
          <ValidationProvider>
            <StateDatePickerInput
              v-model="remindDate"
              leading-icon="icon-date"
              :disabled="remindDateSetting=='auto'"
              :not-before-disabled-date="notBeforeDisabledDate"
              :disabled-date="disabledDate"
              :not-after-disabled-date="notAfterDisabledDate"
              :after-disabled-date="afterDisabledDate"
              :rules="remindDateSetting=='custom'||date === 'permanent' ? rules :''"
              @input="changeValue($event)"
            />
          </ValidationProvider>
          <p
            v-if="_remindDateLaterRecommendDate"
            class="error-message"
          >
            {{ $t('你所設定的提醒日期晚於建議的日期，請確認。') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "StateRadioDatepickerButton",
  components: {
    ValidationProvider,
  },
  props: {
    title: {
      type: String,
      default() {
        return this.$t("續辦提醒日期");
      },
    },
    extensionPeriod: {
      type: Number,
      default: 0,
    },
    recommendPeriod: {
      type: Number,
      default: 0,
    },
    date: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: "",
    },
    rules: {
      type: String,
      default: "",
    },
    notBeforeDisabledDate: {
      type: Boolean,
      default: false,
    },
    disabledDate: {
      type: Date,
      default() {},
    },
    notAfterDisabledDate: {
      type: Boolean,
      default: false,
    },
    afterDisabledDate: {
      type: Date,
      default() {},
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    remindDateSetting: "auto",
    remindDate: "",
  }),
  computed: {
    _recommendPeriod() {
      return !this.recommendPeriod ? 0 : this.recommendPeriod;
    },
    _statitoryExtensionPeriod() {
      if (!this.date || this.date === "permanent") return;
      let extensionDate = this.$moment(this.date).subtract(
        this.extensionPeriod,
        "days"
      );
      let extensionDateFormat =
        this.$moment(extensionDate).format("YYYY-MM-DD");
      return extensionDateFormat;
    },
    _recommendNotifyPeriod() {
      if (!this._statitoryExtensionPeriod) return;
      let extensionDate = this.$moment(this._statitoryExtensionPeriod).subtract(
        this.recommendPeriod,
        "days"
      );
      let extensionDateFormat =
        this.$moment(extensionDate).format("YYYY-MM-DD");
      return extensionDateFormat;
    },
    _remindDateLaterRecommendDate() {
      if (!this.remindDate || !this._recommendNotifyPeriod) return;
      let remindDate = this.$moment(this.remindDate).format('YYYY-MM-DD');
      let secondDate = this.$moment(this._recommendNotifyPeriod).format('YYYY-MM-DD');
      if (this.$moment(remindDate).diff(this.$moment(secondDate), "days") > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    remindDateSetting() {
      this.setRemindDate();
    },
    date: {
      deep: true,
      handler() {
        this.setRemindDate();
      },
    },
    value() {
      this.remindDate = this.value;
    },
  },
  mounted() {
    this.setRemindDate();
    if (!this.value) {
      return;
    }
    this.remindDate = this.value;
    if (this.value != "") {
      this.remindDateSettingByremindDate();
    }
  },
  methods: {
    changeValue() {
      this.$emit("input", this.remindDate);
    },
    setRemindDate() {
      if (this.remindDateSetting === "auto") {
        this.$emit("input", this._recommendNotifyPeriod);
      } else {
        this.$emit("input", this.remindDate);
      }
    },
    remindDateSettingByremindDate() {
      const remindDate = this.$moment(this.remindDate).format("YYYY-MM-DD");
      const recommendDate = this.$moment(this._recommendNotifyPeriod).format(
        "YYYY-MM-DD"
      );
      if (remindDate !== recommendDate) {
        this.remindDateSetting = "custom";
      } else {
        this.remindDateSetting = "auto";
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/state-radio-datepicker-button";
</style>